"use client";
import SectionPage from "@/components/common/section-page";

import { useNavigate } from "react-router-dom";
import {OnlyImageBgCard, PaveScaleCard} from "@/components/common/pave-scale-card";
import EspaceProTitleCard from "@/components/common/espace-pro-title-card";

export default function Home() {
  const navigate = useNavigate();

  return (
          <div className={"flex flex-col gap-6 pb-6 mb-8"}>

            <EspaceProTitleCard title={"Devenir Partenaire"} description={"Participer à la création d’une industrie touristique durable."} />

          {/* Nature & Biodiversité */}
          <SectionPage sectionType="lg">
              <div className={"text-normal text-justify mt-8"}>
                  En tant que partenaire, vous vous connectez au tourisme local et au sein de notre office de tourisme, nous sommes présents pour répondre à vos besoins :
<br/>
                  <ul className={"font-black text-normal list-disc list-inside pl-4 mt-4"}>
                      <li className="li1"><b>Développer votre activité</b></li>
                      <li className="li1"><b>Contribuer au développement touristique de la destination</b></li>
                      <li className="li1"><b>Appartenir à un réseau de pros impliqués dans la réussite de notre
                          destination.</b></li>
                      <li className="li1"><b>Accroître votre visibilité</b></li>
                      <li className="li1"><b>Bénéficier d’un accompagnement professionnel</b></li>
                      <li className="li1"><b>Bénéficier d’une équipe d’experts à votre écoute.</b></li>
                  </ul>

                  Le partenariat offre des outils et des services et c’est grâce à notre approche terrain que nous les
                  développons, en fonction de vos attentes. Nous sommes une équipe à votre disposition, à votre écoute.

              </div>
          </SectionPage>

              <SectionPage sectionType="lg">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6 mb-6">
                      <PaveScaleCard title={"Pourquoi être Partenaire ?"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/devenir-partenaire/pourquoi-etre-partenaire" titleClassName={"font-playfair-display italic font-bold"} />
                      <OnlyImageBgCard imageSrc={"/images/espace-pro/devenir-partenaire/1.jpg"} className={"h-[400px]"} />
                      <PaveScaleCard title={"Le Guide du Partenaire"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/devenir-partenaire/guide-du-partenaire" titleClassName={"font-playfair-display italic font-bold"} />
                      <OnlyImageBgCard imageSrc={"/images/espace-pro/devenir-partenaire/2.jpg"} className={"h-[400px]"} />
                      <PaveScaleCard title={"Tourisme & Capital Humain "} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/devenir-partenaire/tourisme-capital-humain" titleClassName={"font-playfair-display italic font-bold"} />
                  </div>
              </SectionPage>

        </div>
  );
}
